import { AppWindow } from '@insurgrid/common';
import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { readTraceId } from '../traceId';
import { useClient } from './useClient';
import { useClientId } from './useClientId';

export function useHotJar() {
  const { readClientIdFromUrlOrStorage } = useClientId();
  const clientId = readClientIdFromUrlOrStorage();
  const { client } = useClient();
  const pathname = usePathname();
  const query = useSearchParams();

  const agentId = query?.get('agentId');

  useEffect(() => {
    const clientSubmissionId = client?.data.clientSubmissions?.[0]?.uuid;
    // Same traceId every other analytics surface (Segment, client.create,
    // Pigeon job data) already carries — lets a Hotjar recording be
    // correlated with the rest of that session's trace.
    const traceId = readTraceId();

    if (clientId) {
      (window as AppWindow).analytics?.identify(clientId, {
        clientId,
        clientSubmissionId: clientSubmissionId || '',
        traceId,
      });
    }

    if (clientId && agentId) {
      (window as AppWindow).hj?.('identify', agentId, {
        clientId,
        clientSubmissionId: clientSubmissionId || '',
        traceId,
      });
    }
  }, [pathname, client, agentId, clientId]);
}
